import React, { useRef } from 'react'

import { useSelector, shallowEqual } from 'react-redux'
import styled from 'styled-components'

import { PageBlock } from '../'
import { useWindowSize } from '../../_helpers'
import { scrollTo } from '../../_helpers/utils'
import {
    Meta,
    Block,
    Hero,
    StickyImage,
    RedArrow,
    devices,
    HomeLogo
} from '../Common'


const Home = () => {
    const { page } = useSelector(state => state.content, shallowEqual)
    const { intro_image, hero_image, blocks, url } = page
    const scrollRef = useRef()
    const { width } = useWindowSize()
    const mobile = width < 480

    return (
        <>
            <Meta page={page} />
            <Hero>
                {!mobile && <HomeLogo />}
                <RedDownArrow onClick={() => scrollTo(scrollRef.current.offsetTop, 1000)} />
            </Hero>
            <StickyImage background={hero_image} />
            {blocks && blocks.map((pageBlock, i) =>
                <Block ref={i === 0 ? scrollRef : null} key={i.toString()}>
                    <PageBlock pageBlock={pageBlock} url={url} />
                </Block>
            )}

        </>
    )
}

const RedDownArrow = styled(RedArrow)`
    transform: rotate(90deg);
    margin-bottom: 50px;
    cursor: pointer;
    animation-duration: 1s;
    animation-fill-mode: both;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;

    @keyframes bounce {
	    0%, 100%, 20%, 50%, 80% {
	    	-webkit-transform: translateY(0) rotate(90deg);
	    	-ms-transform: translateY(0) rotate(90deg);
	    	transform: translateY(0) rotate(90deg);
	    }
	    40% {
	    	-webkit-transform: translateY(-30px) rotate(90deg);
	    	-ms-transform: translateY(-30px) rotate(90deg);
	    	transform: translateY(-30px) rotate(90deg);
	    }
	    60% {
	    	-webkit-transform: translateY(-15px) rotate(90deg);
	    	-ms-transform: translateY(-15px) rotate(90deg);
	    	transform: translateY(-15px) rotate(90deg);
	    }
    }

    &:hover {
        animation-name: bounce;
        -moz-animation-name: bounce;
    }

    @media ${devices.small} {
        margin-bottom: 130px;
    }
`

export default Home
